export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
  {
    name: 'ImageAnalyst',
    displayName: 'Image analysis',
    meta: {
      iconClass: 'vuestic-iconset-image',
    },
    children: [{
      name: 'ImageAnalystResultsList',
      displayName: 'Processed media items',
    },{
      name:'proccessActiveConsole',
      displayName: 'Process live feed',
    }]
  },
  {
    name: 'watchedItems',
    displayName: 'menu.watched',
    meta: {
      iconClass: 'vuestic-iconset-extras',
    },
    disabled: true,
    children: [{
      name: 'WatchedAccountList',
      displayName: 'Watched Accounts',
    },
    {
      name: 'WatchedMentionList',
      displayName: 'Watched Mentions',
    },
    {
      name: 'WatchedHashtagList',
      displayName: 'Watched Hashtags',
    }, 
    {
      name: 'WatchedPhraseList',
      displayName: 'Watched Phrases',
    }
    ],
  },
  {
    name: 'WatcherProcesses',
    displayName: 'Watcher Processes',
    meta: {
      iconClass: 'vuestic-iconset-settings',
    },
    disabled: true,
    children: [{
      name: 'ManageProcesses',
      displayName: 'Manage Processes',
    }
    ],
  },
  {
    name: 'reports',
    displayName: 'Reports',
    meta: {
      iconClass: 'vuestic-iconset-forms',
    },
    disabled: true,
    children: [{
      name: 'generate',
      displayName: 'Generate',
    },

    ],
  },
  {
    name: 'twitterSearch',
    displayName: 'Twitter Search',
    meta: {
      iconClass: 'vuestic-iconset-graph',
    },
   
  }
  ],
}
